import { call } from '@advanza/api'
import { Button, LoadingDots } from '@advanza/ui'
import { useState } from 'react'

const ExportDemandNativeAppStatsButton = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState('')

    const onClick = async () => {
        setIsLoading(true)
        setError('')
        try {
            const response = await call('office/misc/export-demand-native-app-stats')
            if (!response?.data) {
                throw new Error('No data returned')
            }

            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' })
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = `demand-native-app-stats-${new Date().toISOString().slice(0, 10)}.csv`
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            URL.revokeObjectURL(url)
        } catch (err: unknown) {
            setError(err instanceof Error ? err.message : 'Export failed')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="space-y-2">
            <Button appearance="primary" onClick={onClick} disabled={isLoading}>
                {isLoading && <LoadingDots color="white" />} Export Demand App Stats
            </Button>
            {error && <p className="text-md text-red-600">{error}</p>}
        </div>
    )
}

export default ExportDemandNativeAppStatsButton
